<div class="so-background-container" (mousemove)="handleMouseMove($event)" (mouseleave)="handleMouseLeave()">
  @if (showBackground()) {
    <canvas #decorativeCanvas class="so-background-container__canvas" [ngStyle]="canvasStyles()"></canvas>
  }
  <div class="so-background-container__content">
    <ng-content></ng-content>
  </div>
</div>
